import { createSlice } from '@reduxjs/toolkit';
import errorWrapper from '~/redux/reducers/utils/errorWrapper';
import * as actions from './actions';
const documentSlice = createSlice({
    name: 'document',
    initialState: {
        isDocumentLoading: true,
        document: {},
    },
    reducers: {
        setSelectedClause: (state, action) => {
            state.selectedClause = action.payload.name;
        },
    },
    extraReducers: {
        [actions.getDocumentById.pending]: (state) => {
            state.isDocumentLoading = true;
        },
        [actions.getDocumentById.fulfilled]: (state, action) => {
            state.document = action.payload;
            state.isDocumentLoading = false;
        },
        [actions.getDocumentById.rejected]: (state, action) => {
            var _a;
            state.isDocumentLoading = false;
            if ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.name) {
                const error = new Error(action.error.name);
                error.message = action.error.message;
                throw error;
            }
        },
    },
});
export * from './actions';
export const { setSelectedClause } = documentSlice.actions;
export default errorWrapper(documentSlice.reducer);
